import { IToastProps } from '@blueprintjs/core'

export const DEFAULT_DYMO_CONFIG = {
  scaleContent: false,
  colorType: 'grayscale',
  interpolation: 'nearest-neighbor',
  units: 'in',
  rasterize: false,
  margins: { top: 0.0, right: 0.0, bottom: 0.0, left: 0.0 }
}

export const DEFAULT_ZEBRA_CONFIG = {
  forceRaw: true
}

export const DEFAULT_STAR_ESCPOS_CONFIG = {
  forceRaw: true
}

export const DEFAULT_STAR_PDF_CONFIG = {
  ...DEFAULT_DYMO_CONFIG,
  // This combo prints the clearest on a Star TSP700ii
  rasterize: 'true',
  scaleContent: 'false',
  interpolation: 'nearest-neighbor'
}

export const LISTER_CONNECT_CONNECTION_FAILURE: IToastProps = {
  intent: 'danger',
  message: 'Unable to establish connection with printer',
  action: {
    href: 'https://help.uprightlabs.com/en-us/lister/printers-and-scales#main-content',
    text: 'Get help',
    target: '_blank'
  }
}

export const LISTER_CONNECT_NO_CURRENT_PRINTER: IToastProps = { intent: 'danger', message: 'No current printer setup' }

export const DEFAULT_LABEL_SIZE = { height: 3.5, width: 1.125 }
export const MEDIA_TICKET_SIZE = { height: 8.625, width: 3.5 }
export const DEFAULT_SHIPPING_LABEL_SIZE = { width: 4.0, height: 6.0 }
